import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Eye, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating || !impersonatedUser) return null;

  const handleStop = () => {
    stopImpersonation();
    navigate('/admin');
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 left-0 right-0 z-[9999] bg-amber-500 text-black px-4 py-2 flex items-center justify-between text-sm font-medium shadow-lg"
    >
      <div className="flex items-center gap-2">
        <Eye className="w-4 h-4" />
        <span>
          Viendo como: <strong>{impersonatedUser.email}</strong>
          {impersonatedUser.name ? ` (${impersonatedUser.name})` : ''}
        </span>
      </div>
      <button
        data-testid="stop-impersonation-btn"
        onClick={handleStop}
        className="flex items-center gap-1.5 bg-black/20 hover:bg-black/30 px-3 py-1 rounded-md transition-colors"
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        Volver a mi cuenta
      </button>
    </div>
  );
};

export default ImpersonationBanner;
